import React from 'react';
import { Button } from '../ui/button';
import {
  Square,
  Circle,
  Pencil,
  ArrowRight,
  Type,
  Undo2,
  Trash2,
  ZoomIn,
  ZoomOut,
  Ruler,
  Triangle,
} from 'lucide-react';
import { TOOLS } from './annotatorConstants';

const TOOL_BUTTONS = [
  { tool: TOOLS.RECTANGLE, icon: Square, label: 'Rectangle' },
  { tool: TOOLS.CIRCLE, icon: Circle, label: 'Circle' },
  { tool: TOOLS.FREEHAND, icon: Pencil, label: 'Freehand' },
  { tool: TOOLS.ARROW, icon: ArrowRight, label: 'Arrow' },
  { tool: TOOLS.TEXT, icon: Type, label: 'Text' },
  { tool: TOOLS.RULER, icon: Ruler, label: 'Ruler (Measure)' },
  { tool: TOOLS.ANGLE, icon: Triangle, label: 'Angle (3 clicks)' },
];

const AnnotatorToolbar = ({ tool, setTool, onZoomIn, onZoomOut, onUndo, onClear, annotationCount }) => {
  return (
    <div className="w-16 bg-[#F8F7F4] border-r border-[#E5E4E0] p-2 flex flex-col gap-2">
      {TOOL_BUTTONS.map(({ tool: t, icon: Icon, label }) => (
        <Button
          key={t}
          variant={tool === t ? 'default' : 'ghost'}
          size="sm"
          className={`w-full h-10 p-0 ${tool === t ? 'bg-[#4B6651] text-white' : ''}`}
          onClick={() => setTool(t)}
          title={label}
          data-testid={`tool-${t}`}
        >
          <Icon className="w-4 h-4" />
        </Button>
      ))}

      <div className="border-t border-[#E5E4E0] my-2" />

      <Button variant="ghost" size="sm" className="w-full h-10 p-0" onClick={onZoomIn} title="Zoom In">
        <ZoomIn className="w-4 h-4" />
      </Button>
      <Button variant="ghost" size="sm" className="w-full h-10 p-0" onClick={onZoomOut} title="Zoom Out">
        <ZoomOut className="w-4 h-4" />
      </Button>

      <div className="border-t border-[#E5E4E0] my-2" />

      <Button variant="ghost" size="sm" className="w-full h-10 p-0" onClick={onUndo} title="Undo" disabled={annotationCount === 0}>
        <Undo2 className="w-4 h-4" />
      </Button>
      <Button variant="ghost" size="sm" className="w-full h-10 p-0 text-[#D94F4F] hover:text-[#D94F4F]" onClick={onClear} title="Clear All" disabled={annotationCount === 0}>
        <Trash2 className="w-4 h-4" />
      </Button>
    </div>
  );
};

export default AnnotatorToolbar;
